"use strict";
// Copyright © Veeam Software Group GmbH
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManualBackup = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("@veeam/components");
const core_1 = require("@veeam/core");
const backup_svg_1 = __importDefault(require("../../../../assets/icons/backup.svg"));
const export_svg_1 = __importDefault(require("../../../../assets/icons/export.svg"));
const core_2 = require("../../../../core");
const helpers_1 = require("../../../../helpers");
const ConfigurationBackupModel_1 = require("../../ConfigurationBackupModel");
const helpers_2 = require("./helpers");
require("./types");
const ManualBackup = ({ model, isDisabled, isLoading, status, onBackup, onExport, }) => {
    const { t } = core_2.useFeatureContext();
    const { value: modelValue } = core_1.useModel(model);
    const isPendingStatus = ConfigurationBackupModel_1.ConfigurationBackupModel.isPendingStatus(status);
    const iconSrc = helpers_2.getStatusIconSrc(status);
    const latestRestorePointValue = helpers_2.getLatestRestorePointValue({
        status,
        texts: {
            success: t('configurationBackup|manualBackup|actions|lastBackup|success', {
                time: helpers_1.formatDate(modelValue.restorePointCreationTime),
            }),
            failed: t('configurationBackup|manualBackup|actions|lastBackup|failed'),
            pending: t('configurationBackup|manualBackup|actions|lastBackup|backuping'),
        },
    });
    return (react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.column, gap: components_1.STACK_GAP.s },
        react_1.default.createElement(components_1.TitleH2, null, t('configurationBackup|manualBackup|header')),
        react_1.default.createElement(components_1.Paragraph, null, t('configurationBackup|manualBackup|description')),
        react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.row, gap: components_1.STACK_GAP.m, spaceTop: components_1.INDENT.s },
            react_1.default.createElement(components_1.Text, null, t('configurationBackup|manualBackup|actions|lastBackup|label')),
            react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.row, gap: components_1.STACK_GAP.s },
                iconSrc && react_1.default.createElement(components_1.Icon, { src: iconSrc }),
                react_1.default.createElement(components_1.Text, null, latestRestorePointValue))),
        react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.row, gap: components_1.STACK_GAP.xl },
            react_1.default.createElement(components_1.LinkButton, { iconBefore: backup_svg_1.default, disabled: isDisabled || isPendingStatus, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                    yield onBackup();
                }) }, t('configurationBackup|manualBackup|actions|backup|label')),
            react_1.default.createElement(components_1.LinkButton, { iconBefore: export_svg_1.default, disabled: isDisabled || isLoading || isPendingStatus || !modelValue.restorePointCreationTime, onClick: () => {
                    onExport();
                } }, t('configurationBackup|manualBackup|actions|export|label')))));
};
exports.ManualBackup = ManualBackup;
//# sourceMappingURL=ManualBackup.js.map